import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block-list-chip mt-1" }

import { ref, watch } from 'vue';
import VCollapseContent from './VCollapseContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VChips',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as { items: any[] }



const collapseRef = ref()

watch(() => props.items.length, () => {
  collapseRef.value.update()
}, { flush: "post" })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VCollapseContent, {
    ref_key: "collapseRef",
    ref: collapseRef,
    class: "block-list-chips"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (blockList) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(blockList.name), 1))
      }), 256))
    ]),
    _: 1
  }, 512))
}
}

})